export default __webpack_public_path__ + "locales/sk/EmbeddingPanel.json?hash=41f18e81b52569b03d142506f9180b18";